import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white p-4 rounded-lg mt-4 text-left text-textPrimary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-md font-bold" }, "Jornada de trabalho", -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-md font-semibold" }, "Início", -1)
const _hoisted_6 = { class: "flex items-center gap-2 mt-4" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "text-md font-semibold" }, "Fim", -1)
const _hoisted_10 = { class: "flex items-center gap-2 mt-4" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold" }, "Horas perdidas", -1)
const _hoisted_15 = { class: "mt-2 text-sm text-negative" }

import { computed, PropType } from 'vue'
import { format } from 'date-fns'
import { mdiCalendarBlankOutline } from '@mdi/js'
import { formatDecimalHoursToHHMM } from '@/utils/formatters'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionWorkingDayCard',
  props: {
  startTime: {
    type: Date as PropType<Date>,
    required: true
  },
  endTime: {
    type: Date as PropType<Date>,
    required: true
  },
  lostHours: {
    type: String,
    required: true
  },
  estimatedLoss: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props;



const formattedStartTime = computed(() => {
  return format(props.startTime, "dd/MM/yyyy 'às' HH:mm")
})

const formattedEndTime = computed(() => {
  return format(props.endTime, "dd/MM/yyyy 'às' HH:mm")
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_icon, {
            size: "small",
            icon: _unref(mdiCalendarBlankOutline),
            color: 'iconGrey'
          }, null, 8, ["icon"]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(formattedStartTime.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_icon, {
            size: "small",
            icon: _unref(mdiCalendarBlankOutline),
            color: 'iconGrey'
          }, null, 8, ["icon"]),
          _createElementVNode("span", _hoisted_11, _toDisplayString(formattedEndTime.value), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(formatDecimalHoursToHHMM)(props.lostHours)), 1)
      ])
    ])
  ]))
}
}

})